import { render, staticRenderFns } from "./AdminDashboardPage.vue?vue&type=template&id=1bede5b8&"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=ts&"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bede5b8')) {
      api.createRecord('1bede5b8', component.options)
    } else {
      api.reload('1bede5b8', component.options)
    }
    module.hot.accept("./AdminDashboardPage.vue?vue&type=template&id=1bede5b8&", function () {
      api.rerender('1bede5b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Admin/AdminDashboardPage.vue"
export default component.exports